/**
 * Trigger: tr_account_transfers_delete
 * Purpose: Update account balances when an account transfer is hard deleted
 * Table: account_transfers
 * Event: BEFORE DELETE
 */
export const TR_ACCOUNT_TRANSFERS_DELETE = `
CREATE TRIGGER tr_account_transfers_delete
BEFORE DELETE ON account_transfers FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET transfers_amount = transfers_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_in_id
    AND currency_id = old.currency_id;

  UPDATE account_balances
  SET transfers_amount = transfers_amount + old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_out_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_in_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount + old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_out_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date;

  DELETE FROM account_daily_balances
  WHERE (account_id = old.account_out_id OR account_id = old.account_in_id)
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE (account_id = old.account_out_id OR account_id = old.account_in_id)
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
